import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import * as arrayToTree from 'array-to-tree';
import { treeToArray } from 'tree-with-array';
import { NoteService } from 'src/app/services/note.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { INote } from 'src/app/intefaces/INote';
import { CategoryService } from 'src/app/services/category.service';
import { UserService } from 'src/app/services/user.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

interface RatingFilterSelectedI {
  rate: number;
  value: boolean;
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  categories: Array<any> = [];
  categoriesTree: Array<any> = [];
  // selectedCategories = [];
  arrangers: Array<any> = [];
  searchQuery = '';
  searchNotes: Array<INote> = [];
  page = 1;
  totalResults: number;
  isLoading = true;
  isLoadingFilters = true;
  typingTimeout: any;
  ratingFilterValues = [
    {label: '5.0', value: 5},
    {label: '>4.0', value: 4},
    {label: '>3.0', value: 3},
    {label: '>2.0', value: 2},
  ];
  ratingFilterSelected: RatingFilterSelectedI;
  levelFilter: number;
  dateSort: string;
  priceSort: string;
  popularSort: string;
  titleSort: string;
  arrangerFilterExpanded = false;
  mobileView: boolean;
  showFilters = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private noteService: NoteService,
    private categoryService: CategoryService,
    private userService: UserService,
    private httpAlertService: HttpAlertService,private title: Title,
    private translateService: TranslateService) {
      if (window.innerWidth <= 768) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
    }

   ngOnInit() {
    this.isLoading = true;
    this.isLoadingFilters = true;

    this.categoryService.getCategories().subscribe((catResp) => {
      this.categories = catResp.data;
      const unsortedTree = arrayToTree(catResp.data, {
        parentProperty: 'parent_id'
      });
      this.categoriesTree = this.sortTree(unsortedTree);

      this.userService.getAllArrangers().subscribe((arrResp) => {
        this.arrangers = arrResp.data.arrangers;

        this.route.queryParams.subscribe(params => {
          if (params.category) {
            const categoriesChanged = this.categories;

            if (typeof params.category === 'string') {
              this.categoriesTree = this.changeTree(this.categoriesTree, parseInt(params.category), 'checked', true);
            } else if (Array.isArray(params.category)) {
              params.category.forEach(paramCat => {
                this.categoriesTree = this.changeTree(this.categoriesTree, parseInt(paramCat), 'checked', true);
              });
            }

            this.categories = categoriesChanged;
          }

          if (params.arranger) {
            const arrangersChenged = this.arrangers;

            if (typeof params.arranger === 'string') {
              arrangersChenged.forEach(arr => {
                if (arr.id === parseInt(params.arranger)) {
                  arr.checked = true;
                }
              });
            } else if (Array.isArray(params.arranger)) {
              arrangersChenged.forEach(arr => {
                const foundArr = params.arranger.find(a => parseInt(a) === arr.id);
                if (foundArr) {
                  arr.checked = true;
                }
              });
            }

            this.arrangers = arrangersChenged;
          }

          if (params.text) {
            this.searchQuery = params.text;
          }

          if (params.level) {
            this.levelFilter = parseInt(params.level);
          }

          if (params.rate) {
            this.ratingFilterSelected = {
              rate: parseInt(params.rate),
              value: true
            };
          }

          if (params.dateSort) {
            this.dateSort = params.dateSort;
          }

          if (params.priceSort) {
            this.priceSort = params.priceSort;
          }

          if (params.popularSort) {
            this.popularSort = params.popularSort;
          }

          if (params.titleSort) {
            this.titleSort = params.titleSort;
          }

          this.isLoadingFilters = false;

          this.searchTracks(1);
        });

      });

    });

    this.translateService.get('title_music_notes').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

  handleRatingFilterSelected(e, i) {
    this.ratingFilterSelected = {
      rate: i,
      value: e.checked
    };
    this.handleFiltersChange();
  }

  handleLevelChange(l) {
    this.levelFilter = l;
    this.handleFiltersChange();
  }

  handleDateSort() {
    if (!this.dateSort) {
      this.dateSort = 'new';
    } else if (this.dateSort === 'new') {
      this.dateSort = 'old';
    } else if (this.dateSort === 'old') {
      this.dateSort = 'new';
    }

    this.priceSort = null;
    this.popularSort = null;
    this.titleSort = null;
    this.handleFiltersChange();
  }

  handlePriceSort() {
    if (!this.priceSort) {
      this.priceSort = 'low';
    } else if (this.priceSort === 'low') {
      this.priceSort = 'high';
    } else if (this.priceSort === 'high') {
      this.priceSort = 'low';
    }

    this.dateSort = null;
    this.popularSort = null;
    this.titleSort = null;
    this.handleFiltersChange();
  }

  handlePopularSort() {
    if (!this.popularSort) {
      this.popularSort = 'yes';
    } else if (this.popularSort === 'yes') {
      this.popularSort = 'no';
    } else if (this.popularSort === 'no') {
      this.popularSort = 'yes';
    }

    this.priceSort = null;
    this.dateSort = null;
    this.titleSort = null;
    this.handleFiltersChange();
  }

  handleTitleSort() {
    if (!this.titleSort) {
      this.titleSort = 'A';
    } else if (this.titleSort === 'A') {
      this.titleSort = 'Z';
    } else if (this.titleSort === 'Z') {
      this.titleSort = 'A';
    }

    this.priceSort = null;
    this.dateSort = null;
    this.popularSort = null;
    this.handleFiltersChange();
  }

  changeTree = (array, id, param, value) => {
    const updatedTree = [...array];
    const index = updatedTree.findIndex(obj => obj.id === id);

    if (updatedTree[index]) {
      updatedTree[index] = {
        ...updatedTree[index],
        [param]: value,
      };

      if (param === 'checked' && value) {
        updatedTree[index] = {
          ...updatedTree[index],
          expanded: true
        };
      }

      if (param === 'checked' && value && updatedTree[index].children) {
        updatedTree[index].children.forEach((child, i) => {
          child.checked = true;
        });
      } else if (param === 'checked' && !value && updatedTree[index].children) {
        updatedTree[index].children.forEach((child, i) => {
          child.checked = false;
        });
      }
    } else {
        updatedTree.forEach((el, i) => {
          if (el.children) {
              updatedTree[i].children = this.changeTree(el.children, id, param, value);
          }
        });
    }

    updatedTree.forEach((element, i) => {
      if (element.children) {
        let counter = 0;
        element.children.forEach(childEl => {
          if (childEl.checked) {
            counter = counter + 1;
          }
        });

        if (counter && element.children.length > counter) {
          updatedTree[i] = {
            ...updatedTree[i],
            checked: false,
            expanded: true
          }
        }
      }
    });

    return updatedTree;
  };

  nodeToggle(node) {
    if (node.children && node.children.length > 0) {
      this.categoriesTree = this.changeTree(this.categoriesTree, node.id, 'expanded', !node.expanded);
    }
  }

  nodeSelect(event, node) {
    this.categoriesTree = this.changeTree(this.categoriesTree, node.id, 'checked', event.checked);
    this.handleFiltersChange();
  }

  handleFiltersChange() {
    const checkedCategories = [];
    const list = treeToArray(this.categoriesTree);
    list.forEach(cat => {
      if (cat.checked) {
        checkedCategories.push(cat.id);
      }
    });

    const checkedArrangers = [];
    this.arrangers.forEach(arr => {
      if (arr.checked) {
        checkedArrangers.push(arr.id);
      }
    });

    const queryParams: Params = {
      text: this.searchQuery,
      category: checkedCategories,
      arranger: checkedArrangers,
      level: this.levelFilter,
      rate: this.ratingFilterSelected && this.ratingFilterSelected.value
        ? this.ratingFilterSelected.rate
        : null,
      dateSort: this.dateSort,
      priceSort: this.priceSort,
      popularSort: this.popularSort,
      titleSort: this.titleSort,
    };

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  onInputTyping(event) {
    clearTimeout(this.typingTimeout);
    this.typingTimeout = setTimeout(() => {
      this.handleFiltersChange();
    }, 500);
  }

  clearLevel() {
    this.levelFilter = null;
    this.handleFiltersChange();
  }

  searchTracks(pagination: number) {
    this.isLoading = true;

    const checkedCategories = [];
    const list = treeToArray(this.categoriesTree);
    list.forEach(cat => {
      if (cat.checked) {
        checkedCategories.push(cat.id);
      }
    });

    const checkedArrangers = [];
    this.arrangers.forEach(arr => {
      if (arr.checked) {
        checkedArrangers.push(arr.id);
      }
    });

    const obj = {
      text: this.searchQuery,
      categories: checkedCategories,
      arrangers: checkedArrangers,
      rate: this.ratingFilterSelected && this.ratingFilterSelected.value
        ? this.ratingFilterValues[this.ratingFilterSelected.rate].value
        : null,
      level: this.levelFilter ? this.levelFilter : null,
      dateSort: this.dateSort ? this.dateSort : null,
      priceSort: this.priceSort ? this.priceSort : null,
      popularSort: this.popularSort ? this.popularSort : null,
      titleSort: this.titleSort ? this.titleSort : null,
      page: pagination
    };

    this.noteService.getNotesByFilters(obj).subscribe(response => {
      if (response.success) {
        if (pagination === 1) {
          this.searchNotes = response.data.data;
        } else {
          this.searchNotes = this.searchNotes.concat(response.data.data);
        }

        this.totalResults = response.data.total;
      }
      this.isLoading = false;
    }, (err) => {
      this.httpAlertService.error(err.error.message);
      this.isLoading = false;
    });
  }

  sortTree(tree) {
    let sortedTree = [...tree];
    sortedTree = sortedTree.sort((a,b) => (a.orderIndex > b.orderIndex) ? 1 : ((b.orderIndex > a.orderIndex) ? -1 : 0));

    sortedTree = sortedTree.map((node, index) => {
      if (node.children && node.children.length > 0) {
        return sortedTree[index] = {
          ...sortedTree[index],
          children: sortedTree[index].children.sort((a,b) => (a.orderIndex > b.orderIndex) ? 1 : ((b.orderIndex > a.orderIndex) ? -1 : 0))
        };
      } else {
        return sortedTree[index];
      }
    });

    return sortedTree;
  }

  clearAllFilters() {
    this.searchQuery = '';
    this.levelFilter = null;
    this.ratingFilterSelected = null;
    this.dateSort = null;
    this.priceSort = null;
    this.popularSort = null;
    this.titleSort = null;
    this.categories.forEach(cat => {
      cat.checked = false;
    });
    const unsortedTree = arrayToTree(this.categories, {
      parentProperty: 'parent_id'
    });
    this.categoriesTree = this.sortTree(unsortedTree);
    this.arrangers.forEach(arr => {
      arr.checked = false;
    });

    const queryParams: Params = {
      text: this.searchQuery,
      category: [],
      arranger: [],
      level: this.levelFilter,
      rate: this.ratingFilterSelected,
      dateSort: this.dateSort,
      priceSort: this.priceSort,
      popularSort: this.popularSort,
      titleSort: this.titleSort,
    };

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  onScroll() {
    if (this.isLoading || this.searchNotes.length >= this.totalResults) {
      return;
    } else {
      this.searchTracks(this.page + 1);
      this.page += 1;
    }
  }

  expandArrangerFilter() {
    this.arrangerFilterExpanded = true;
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

}
